export default __webpack_public_path__ + "static/media/FLEXi-cover.492376eb.png";